import React from "react";
import { ProgressBar } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFileAlt } from "@fortawesome/free-regular-svg-icons";
import "./ErrorDocProgressLoader.css"

interface ErrorDocProgressLoaderProps {
  progress?: number; // 0–100
}

const ErrorDocProgressLoader: React.FC<ErrorDocProgressLoaderProps> = ({
  progress = 0,
}) => {
  return (
    <div className="er_si_progress_loader_wrapper">
      <div className="er_si_progress_loader_card text-center">
        {/* File Icon */}
        <div className="er_si_file_icon_wrapper">
          <FontAwesomeIcon icon={faFileAlt} className="er_si_file_icon" />
          <span className="er_si_file_spinner" />
        </div>

        <h5 className="er_si_progress_title">Loading Document</h5>

        <p className="er_si_progress_desc">
          Please wait while we load your file…
        </p>

        <div className="er_si_progress_bar_wrapper">
          <ProgressBar now={progress} />
          <span className="er_si_progress_text">
            Loading… {progress}%
          </span>
        </div>
      </div>
    </div>
  );
};

export default ErrorDocProgressLoader;
